/**
 * The setup step for every pool type except Survivor (ISSUE-1334). Mounts the
 * type's own step from its feature folder; this file is only the switch.
 */
import type { ReactNode } from "react";

import { PickemCreateSetupStep } from "../pickem/PickemCreateSetupStep";
import { SquaresCreateSetupStep } from "../squares/SquaresCreateSetupStep";
import { StripCardCreateSetupStep } from "../strips/StripCardCreateSetupStep";
import type { typeCreatePoolDraft } from "./createPoolDraft";
import type {
  typePoolTypeSetups,
  typeSetupSlotPoolType,
} from "./poolTypeSetups";

export type typeCreatePoolTypeSetupStepProps = {
  contestType: typeSetupSlotPoolType;
  draft: typeCreatePoolDraft;
  onChangeSetups: (next: typePoolTypeSetups) => void;
};

export const CreatePoolTypeSetupStep = ({
  contestType,
  draft,
  onChangeSetups,
}: typeCreatePoolTypeSetupStepProps): ReactNode =>
  contestType === "pickem" ? (
    <PickemCreateSetupStep
      sportKey={draft.sportKey}
      leagueKey={draft.leagueKey}
      setup={draft.typeSetups.pickem}
      onChangeSetup={(pickem) => {
        onChangeSetups({ ...draft.typeSetups, pickem });
      }}
    />
  ) : contestType === "squares" ? (
    <SquaresCreateSetupStep
      sportKey={draft.sportKey}
      leagueKey={draft.leagueKey}
      setup={draft.typeSetups.squares}
      onChangeSetup={(squares) => {
        onChangeSetups({ ...draft.typeSetups, squares });
      }}
    />
  ) : (
    <StripCardCreateSetupStep
      sportKey={draft.sportKey}
      leagueKey={draft.leagueKey}
      setup={draft.typeSetups.stripCard}
      onChangeSetup={(stripCard) => {
        onChangeSetups({ ...draft.typeSetups, stripCard });
      }}
    />
  );
